__turbopack_context__.v({
  "statisticNumber": "statistic-number-module__U0zFcW__statisticNumber",
  "title": "statistic-number-module__U0zFcW__title",
  "titleBlock": "statistic-number-module__U0zFcW__titleBlock",
});
